"use client"

import { useState } from "react"

interface CareerPathData {
  name: string
  percentage: number
  color: string
}

interface CareerPathChartProps {
  data: CareerPathData[]
}

export function CareerPathChart({ data }: CareerPathChartProps) {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null)

  return (
    <div className="bg-card rounded-3xl p-6 shadow-lg border border-border">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-bold text-foreground">Career Path Distribution</h3>
          <p className="text-sm text-muted-foreground">Student interest across fields.</p>
        </div>
        <select className="text-sm border-border rounded-lg bg-muted py-1.5 pl-3 pr-8 focus:ring-primary focus:border-primary">
          <option>All Grades</option>
          <option>JSS 1</option>
          <option>JSS 2</option>
          <option>JSS 3</option>
          <option>SSS 1</option>
          <option>SSS 2</option>
          <option>SSS 3</option>
        </select>
      </div>

      <div className="h-64 flex items-end justify-around gap-2 px-4 relative">
        {/* Grid lines */}
        <div className="absolute inset-0 flex flex-col justify-between pointer-events-none pb-8 px-4 opacity-30">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="border-b border-border w-full h-0"></div>
          ))}
        </div>

        {/* Bars */}
        {data.map((item, index) => (
          <div
            key={item.name}
            className="flex flex-col items-center gap-2 group w-full z-10 relative"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div className="relative w-full max-w-[52px] h-52 flex items-end">
              <div
                className="w-full rounded-t-lg transition-all duration-500 ease-out border-2 border-transparent hover:opacity-70"
                style={{
                  height: `${item.percentage}%`,
                  backgroundColor: item.color,
                }}
              >
                {hoveredIndex === index && (
                  <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-slate-800 text-white text-xs py-1 px-2 rounded whitespace-nowrap">
                    {item.percentage}%
                  </div>
                )}
              </div>
            </div>
            <span className="text-xs text-muted-foreground font-bold text-center">{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
